// extracted by mini-css-extract-plugin
export default {"selectContent":"HeadOfCampaignCalendar_selectContent__s3ZPx"};